export default "__VITE_ASSET__vSO3EY_G__"